import type { BubbleMetrics } from "@/features/shared/draggable-bubble";

/**
 * Mirrors the stock support launcher exactly: a 48x48 circle sitting 20px from
 * the right and bottom edges, so replacing it with our draggable button is not
 * a visible change until someone actually drags it.
 *
 * `inset` is all-zero because the box IS the circle — the elevation is a CSS
 * `box-shadow`, which takes no layout space (unlike the Birdie bubble's SVG
 * drop-shadow padding, which is why that one has asymmetric insets).
 *
 * `topGap: 80` clears the tallest member header — `MyPlaceLayout`'s
 * `h-[65px] sticky top-0` bar and `PublicHeader`'s `h-16` — with margin.
 * `support-bubble-metrics.test.ts` pins the resting spot.
 */
export const SUPPORT_BUBBLE_METRICS: BubbleMetrics = {
  box: { width: 48, height: 48 },
  inset: { top: 0, right: 0, bottom: 0, left: 0 },
  circle: 48,
  edgeGap: 20,
  topGap: 80,
  defaultBottomGap: 20,
};

export const SUPPORT_BUBBLE_STORAGE_KEY = "support-bubble-position";
